/*
insert into i18rs (
  _key,_vsn,_ltt,_fst,
  _dmn,i18r_31r1f,
  _icn,_pfx,_ctn,
  i18ri15r1f,
  i18rt1100i,
  i18ra1100s,
  "createdAt","updatedAt",_dlt
) VALUES (
  8,1,1,8,
  1,1,
  '2','団体2','特記事項なし',
  1,
  -1,
  'だんたい２',
  '2000-01-01 00:00:00','2000-01-01 00:00:00',-1
);

*/

//import * as hf from 'lib/_hf';
//import { f } from 'lib';
import * as _hm from './_hf';
import * as _hmFTH from './_hmFTH';
import * as _ht from './_ht';

export const grtPzForLoadI18rPs = (uz: _ht.uz, pz: {
  _31r_fst?: _ht.n, // 施設またぎがあるため、通常、_31r_fst を指定しない
  i18r_fst?: _ht.n,
  id?: _ht.s,
  word?: _ht.s,
  lwrz?: {
    i15rs?: _ht.b,
    i16rs?: _ht.b,
  },
}) => {
  let _cdn = _hmFTH.vdd(uz);
  if (pz?._31r_fst && pz?._31r_fst > 0) _cdn += ` AND i18r_31r1f = ${pz?._31r_fst}`;
  if (pz?.word) _cdn += ` AND (i18rab100s LIKE '%${pz?.word}%' OR i18ra1100s LIKE '%${pz?.word}%' OR _pfx LIKE '%${pz?.word}%')`
  //  if (pz?.id) _cdn += ` AND (i18ra4120s = '${pz?.id}%' OR i18ra4220s = '${pz?.id}%' OR i18ra4320s = '${pz?.id}%')`
  if (pz?.i18r_fst && pz?.i18r_fst > 0) _cdn += ` AND _fst = ${pz.i18r_fst}`;
  if (pz?.id) _cdn += ` AND (i18ra4120s = '${pz?.id}' OR i18ra4220s = '${pz?.id}' OR i18ra4320s = '${pz?.id}')`
  //_hm.l(`ihdI18 43: ${_cdn}`);
  return {
    tgt: 'i18rs',
    cdn: _cdn,
    fld: `_fst as key, i18rab100s || ' ' || _pfx as pfx, i18rab100s || _pfx || i18ra1100s as sch, *`,
    tailz: {
      odr: 'i18rab100s',
    },
    lwrz: {
      i15rs: 
        pz?.lwrz?.i15rs ? // 団体種別
        {
          tgt: 'i15rs',
          cdn: _hmFTH.vdd(uz) + ` AND _fst = {i18ri15r1f}`,
          rlcz: {
            i18ri15r1f: 'i18rs.i18ri15r1f'
          }
        }
        : undefined,
      i16rs: 
        pz?.lwrz?.i16rs ? // ジャンル
        {
          tgt: 'i16rs',
          cdn: _hmFTH.vdd(uz) + ` AND _fst = {i18ri16r1f}`,
          rlcz: {
            i18ri16r1f: 'i18rs.i18ri16r1f'
          }
        }
        : undefined,
    }
  };
};

export const i18z = {
  i18r: { // 団体
    v0: {
      itlz: {
        i18r_31r1f: -1,
        i18ri15r1f: -1,
        i18ri16r1f: -1,
        i18rd1100s: '',
        i18rt1100i: -1,
        i18ra1100s: '',
        i18ra2110s: '',
        i18ra2120s: '',
        i18ra3100s: '',
        i18ra3200s: '',
        i18ra3300s: '',
        i18ra3400s: '',
        i18ra3510s: '',
        i18ra3520s: '',
        i18ra4110s: '',
        i18ra4120s: '',
        i18ra4130s: '',
        i18ra4210s: '',
        i18ra4220s: '',
        i18ra4230s: '',
        i18ra4310s: '',
        i18ra4320s: '',
        i18ra4330s: '',
        i18ra5100s: '',
        i18ra5210i: -1,
        i18ra5220i: -1,
        i18ra5230i: -1,
        i18ra5300s: '',
        i18ra6100s: '',
        i18ra6200s: '',
        i18ra6310i: -1,
        i18ra6320i:  0,
        i18ra6400i: -1,
        i18ra6500s: '',
        i18ra7100i: -1,
        i18ra7200s: '',
        i18ra7310i:  0,
        i18ra7320i:  0,
        i18ra7330i:  0,
        i18ra7340i:  0,
        i18ra8100i: -1,
        i18ra8200i:  0,
        i18ra8300i: -1,
        i18ra9110s: '',
        i18ra9120s: '',
        i18ra9210s: '',
        i18ra9220s: '',
        i18raa100i: -1,
        i18raa200i:  0,
        i18raa300i: -1,
        i18rab100s: '',
      },
      fldz: {
        i18r_31r1f: {
          pfx: '施設' 
        },
        i18ri15r1f: {
          pfx: '団体種別',
        },
        i18ri16r1f: {
          pfx: 'ジャンル',
        },

        i18rd1100s: {
          pfx: '登録日',
        },

        i18rt1100i: {
          pfx: '利用制限',
          ls: [
            { key: -1, pfx: 'なし'},
            { key:  1, pfx: 'あり'},
          ]
        },

        _icn: {
          pfx: '団体ID', // 同一ドメイン内でユニーク
          atrs: [
            {
              qry: `
                UPDATE
                  i18rs
                SET
                  _icn = (
                    SELECT
                      LPAD(
                        (
                          MAX(
                            CASE
                              WHEN
                                _icn = ''
                              THEN
                                0
                              ELSE
                                COALESCE(_icn,'0')::NUMERIC
                            END
                          )+1
                        )::TEXT,
                        5,
                        '0'
                      )
                    FROM
                      i18rs AS A
                    WHERE
                      A._dmn = i18rs._dmn
                      AND COALESCE(A._dlt,-1) <> 1
                      AND A._vsn = A._ltt
                      AND A._fst <= i18rs._fst
                      AND A.i18r_31r1f = i18rs.i18r_31r1f
                  )
                WHERE
                  _dmn = {i18r_dmn}
                  AND COALESCE(_dlt,-1) <> 1
                  AND _vsn = _ltt
                  AND _fst = {i18r_fst}
                  AND COALESCE(_icn,'') = ''
              `, // 空白の場合のみ設定対象
              rlcz: {
                i18r_dmn: 'i18rs._dmn',
                i18r_fst: 'i18rs._fst',
              }
            }
          ]
        },
        _pfx: {
          pfx: '団体名',
        },

        i18ra1100s: {
          pfx: '団体名かな',
        },

        i18ra2110s: {
          pfx: '代表者名',
        },
        i18ra2120s: {
          pfx: '代表者名かな',
        },

        i18ra2130s: {
          pfx: '連絡先名',
        },
        i18ra2140s: {
          pfx: '連絡先かな',
        },

        i18ra3100s: {
          pfx: '郵便番号',
        },
        i18ra3200s: {
          pfx: '都道府県',
        },
        i18ra3300s: {
          pfx: '市区町番地',
        },
        i18ra3400s: {
          pfx: '建物・部屋番等',
        },
        i18ra3510s: {
          pfx: '電話番号（主）',
        },
        i18ra3520s: {
          pfx: '電話番号（副）',
        },

        i18ra4110s: {
          pfx: 'メール（主）',
          atrs: [
            {
              qry: `
                INSERT INTO
                  _10rs
                (
                  _dmn,
                  _icn,
                  _10r_31r1f,
                  _10rt1100i,
                  _10ra1100s,
                  "createdAt",
                  "updatedAt"
                ) 
                SELECT
                  i18rs._dmn,
                  i18rs._fst || '_1',
                  i18rs.i18r_31r1f,
                  10,
                  i18rs.i18ra4110s,
                  now(),
                  now()
                FROM
                  i18rs
                WHERE
                  COALESCE(_dlt,-1)<>1 AND _vsn=_ltt
                  AND _fst={i18r_fst}
                ON CONFLICT ON CONSTRAINT _10r_unq1
                DO NOTHING
              `,
              rlcz: {
                i18r_fst: 'i18rs._fst',
              }
            },
            {
              qry: `
                UPDATE
                  _10rs
                SET
                  _10ra1100s = (
                    SELECT
                      COALESCE(i18rs.i18ra4110s,'')
                    FROM
                      i18rs
                    WHERE
                      COALESCE(_dlt,-1)<>1 AND _vsn=_ltt
                      AND i18rs.i18r_31r1f = _10rs._10r_31r1f
                      AND _fst = {i18r_fst}
                  )
                WHERE
                  _dmn = {i18r_dmn} AND COALESCE(_dlt,-1)<>1
                  AND _10rs._10rt1100i = 10
                  AND _10rs._icn = '{i18r_fst}' || '_1'
              `,
              rlcz: {
                i18r_dmn: 'i18rs._dmn',
                i18r_fst: 'i18rs._fst',
              }
            },
          ]
        },
        i18ra4120s: {
          pfx: 'ID（主）',
          atrs20: [ // ログイン方式２の場合
            { // メールアドレスの登録が先に行われている前提
              qry: `
                UPDATE
                  _10rs
                SET
                  _10ra2100s = (
                    SELECT
                      COALESCE(i18rs.i18ra4120s,'')
                    FROM
                      i18rs
                    WHERE
                      COALESCE(_dlt,-1)<>1 AND _vsn=_ltt
                      AND i18rs.i18r_31r1f = _10rs._10r_31r1f
                      AND _fst::TEXT || '_1'  = _10rs._icn
                  )
                WHERE
                  _dmn = {i18r_dmn} AND COALESCE(_dlt,-1)<>1
                  AND _10rs._10rt1100i = 10
                  AND _10rs._icn = '{i18r_fst}' || '_1'
              `,
              rlcz: {
                i18r_dmn: 'i18rs._dmn',
                i18r_fst: 'i18rs._fst',
              }
            },
          ],
          atrs30: [ // ログイン方式３の場合
            { // メールアドレスの登録が先に行われている前提
              qry: `
                UPDATE
                  _10rs
                SET
                  _10ra2100s = (
                    SELECT
                      COALESCE(i18rs.i18rab100s,'')
                    FROM
                      i18rs
                    WHERE
                      COALESCE(_dlt,-1)<>1 AND _vsn=_ltt
                      AND i18rs.i18r_31r1f = _10rs._10r_31r1f
                      AND _fst::TEXT || '_1'  = _10rs._icn
                  )
                WHERE
                  _dmn = {i18r_dmn} AND COALESCE(_dlt,-1)<>1
                  AND _10rs._10rt1100i = 10
                  AND _10rs._icn = '{i18r_fst}' || '_1'
              `,
              rlcz: {
                i18r_dmn: 'i18rs._dmn',
                i18r_fst: 'i18rs._fst',
              }
            },
          ]
        },
        i18ra4130s: {
          pfx: 'パスワード（主）',
          atrs: [
            {
              qry: `
                INSERT INTO
                  _101s
                (
                  _dmn,
                  _101_31r1f,
                  _101_10r1k,
                  _101a1100s,
                  _101a2100i,
                  "createdAt",
                  "updatedAt"
                ) 
                SELECT
                  i18rs._dmn,
                  i18rs.i18r_31r1f,
                  (
                    SELECT 
                      _key 
                    FROM
                      _10rs 
                    WHERE 
                      _dmn=i18rs._dmn AND COALESCE(_dlt,-1)<>1 
                      AND _icn = i18rs._fst::TEXT || '_1'
                  ),
                  i18rs.i18ra4130s,
                  0,
                  now(),
                  now()
                FROM
                  i18rs
                WHERE
                  _dmn = {i18r_dmn} AND COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt
                  AND _fst = {i18r_fst}
                ON CONFLICT ON CONSTRAINT _101_unq1
                DO NOTHING
              `,
              rlcz: {
                i18r_dmn: 'i18rs._dmn',
                i18r_fst: 'i18rs._fst',
              }
            },
            {
              qry: `
                UPDATE
                  _101s
                SET
                  _101a1100s = (
                    SELECT
                      COALESCE(i18rs.i18ra4130s,'')
                    FROM
                      i18rs
                    WHERE
                      COALESCE(_dlt,-1)<>1 AND _vsn=_ltt
                      AND i18rs.i18r_31r1f = _101s._101_31r1f
                      AND _fst::TEXT || '_1'  = (
                        SELECT
                          _icn
                        FROM
                          _10rs
                        WHERE
                          COALESCE(_dlt,-1) <> 1
                          AND _key = _101_10r1k
                      )
                  )
                WHERE
                  COALESCE(_dlt,-1) <> 1
                  AND _101s._101_10r1k IN (
                    SELECT
                      _key
                    FROM
                      _10rs
                    WHERE
                      _dmn = {i18r_dmn} AND COALESCE(_dlt,-1) <> 1
                      AND _10rt1100i = 10
                      AND _icn = '{i18r_fst}' || '_1'
                  )
              `,
              rlcz: {
                i18r_dmn: 'i18rs._dmn',
                i18r_fst: 'i18rs._fst',
              }
            },
          ]
        },
        i18ra4210s: {
          pfx: 'メール（副1）',
          atrs: [
            {
              qry: `
                INSERT INTO
                  _10rs
                (
                  _dmn,
                  _icn,
                  _10r_31r1f,
                  _10rt1100i,
                  "createdAt",
                  "updatedAt"
                ) 
                SELECT
                  i18rs._dmn,
                  i18rs._fst || '_2',
                  i18rs.i18r_31r1f,
                  10,
                  now(),
                  now()
                FROM
                  i18rs
                WHERE
                  COALESCE(_dlt,-1)<>1 AND _vsn=_ltt
                  AND _fst={i18r_fst}
                ON CONFLICT ON CONSTRAINT _10r_unq1
                DO NOTHING
              `,
              rlcz: {
                i18r_fst: 'i18rs._fst',
              }
            },
            {
              qry: `
                UPDATE
                  _10rs
                SET
                  _10ra1100s = (
                    SELECT
                      COALESCE(i18rs.i18ra4210s,'')
                    FROM
                      i18rs
                    WHERE
                      COALESCE(_dlt,-1)<>1 AND _vsn=_ltt
                      AND i18rs.i18r_31r1f = _10rs._10r_31r1f
                      AND _fst = {i18r_fst}
                  )
                WHERE
                  COALESCE(_dlt,-1)<>1
                  AND _10rs._10rt1100i = 10
                  AND _10rs._icn = '{i18r_fst}' || '_2'
              `,
              rlcz: {
                i18r_fst: 'i18rs._fst',
              }
            },
          ]
        },
        i18ra4220s: {
          pfx: 'ID（副1）',
          atrs: [
            { // メールアドレスの登録が先に行われている前提
              qry: `
                UPDATE
                  _10rs
                SET
                  _10ra2100s = (
                    SELECT
                      COALESCE(i18rs.i18ra4220s,'')
                    FROM
                      i18rs
                    WHERE
                      COALESCE(_dlt,-1)<>1 AND _vsn=_ltt
                      AND i18rs.i18r_31r1f = _10rs._10r_31r1f
                      AND _fst = {i18r_fst}
                  )
                WHERE
                  COALESCE(_dlt,-1)<>1
                  AND _10rs._10rt1100i = 10
                  AND _10rs._icn = '{i18r_fst}' || '_2'
              `,
              rlcz: {
                i18r_fst: 'i18rs._fst',
              }
            },
          ]
        },
        i18ra4230s: {
          pfx: 'パスワード（副1）',
          atrs: [
            {
              qry: `
                INSERT INTO
                  _101s
                (
                  _dmn,
                  _101_31r1f,
                  _101_10r1k,
                  _101a1100s,
                  _101a2100i,
                  "createdAt",
                  "updatedAt"
                ) 
                SELECT
                  i18rs._dmn,
                  i18rs.i18r_31r1f,
                  (
                    SELECT 
                      _key 
                    FROM
                      _10rs 
                    WHERE 
                      COALESCE(_dlt,-1)<>1 
                      AND _dmn=i18rs._dmn
                      AND _icn=i18rs._fst || '_2'
                  ),
                  i18rs.i18ra4230s,
                  0,
                  now(),
                  now()
                FROM
                  i18rs
                WHERE
                  COALESCE(_dlt,-1)<>1 AND _vsn=_ltt
                  AND _fst={i18r_fst}
                ON CONFLICT ON CONSTRAINT _101_unq1
                DO NOTHING
              `,
              rlcz: {
                i18r_fst: 'i18rs._fst',
              }
            },
            {
              qry: `
                UPDATE
                  _101s
                SET
                  _101a1100s = (
                    SELECT
                      COALESCE(i18rs.i18ra4230s,'')
                    FROM
                      i18rs
                    WHERE
                      COALESCE(_dlt,-1)<>1 AND _vsn=_ltt
                      AND i18rs.i18r_31r1f = _101s._101_31r1f
                      AND _fst = {i18r_fst}
                  )
                WHERE
                  COALESCE(_dlt,-1)<>1
                  AND _101s._101_10r1k = (
                    SELECT
                      _key
                    FROM
                      _10rs
                    WHERE
                      COALESCE(_dlt,-1)<>1
                      AND _10rt1100i = 10
                      AND _icn = '{i18r_fst}' || '_2'
                  )
              `,
              rlcz: {
                i18r_fst: 'i18rs._fst',
              }
            },
          ]
        },
        i18ra4310s: {
          pfx: 'メール（副2）',
          atrs: [
            {
              qry: `
                INSERT INTO
                  _10rs
                (
                  _dmn,
                  _icn,
                  _10r_31r1f,
                  _10rt1100i,
                  "createdAt",
                  "updatedAt"
                ) 
                SELECT
                  i18rs._dmn,
                  i18rs._fst || '_3',
                  i18rs.i18r_31r1f,
                  10,
                  now(),
                  now()
                FROM
                  i18rs
                WHERE
                  COALESCE(_dlt,-1)<>1 AND _vsn=_ltt
                  AND _fst={i18r_fst}
                ON CONFLICT ON CONSTRAINT _10r_unq1
                DO NOTHING
              `,
              rlcz: {
                i18r_fst: 'i18rs._fst',
              }
            },
            {
              qry: `
                UPDATE
                  _10rs
                SET
                  _10ra1100s = (
                    SELECT
                      COALESCE(i18rs.i18ra4310s,'')
                    FROM
                      i18rs
                    WHERE
                      COALESCE(_dlt,-1)<>1 AND _vsn=_ltt
                      AND i18rs.i18r_31r1f = _10rs._10r_31r1f
                      AND _fst = {i18r_fst}
                  )
                WHERE
                  COALESCE(_dlt,-1)<>1
                  AND _10rs._10rt1100i = 10
                  AND _10rs._icn = '{i18r_fst}' || '_3'
              `,
              rlcz: {
                i18r_fst: 'i18rs._fst',
              }
            },
          ]
        },
        i18ra4320s: {
          pfx: 'ID（副2）',
          atrs: [
            { // メールアドレスの登録が先に行われている前提
              qry: `
                UPDATE
                  _10rs
                SET
                  _10ra2100s = (
                    SELECT
                      COALESCE(i18rs.i18ra4320s,'')
                    FROM
                      i18rs
                    WHERE
                      COALESCE(_dlt,-1)<>1 AND _vsn=_ltt
                      AND i18rs.i18r_31r1f = _10rs._10r_31r1f
                      AND _fst = {i18r_fst}
                  )
                WHERE
                  COALESCE(_dlt,-1)<>1
                  AND _10rs._10rt1100i = 10
                  AND _10rs._icn = '{i18r_fst}' || '_3'
              `,
              rlcz: {
                i18r_fst: 'i18rs._fst',
              }
            },
          ]
        },
        i18ra4330s: {
          pfx: 'パスワード（副2）',
          atrs: [
            {
              qry: `
                INSERT INTO
                  _101s
                (
                  _dmn,
                  _101_31r1f,
                  _101_10r1k,
                  _101a1100s,
                  _101a2100i,
                  "createdAt",
                  "updatedAt"
                ) 
                SELECT
                  i18rs._dmn,
                  i18rs.i18r_31r1f,
                  (
                    SELECT 
                      _key 
                    FROM
                      _10rs 
                    WHERE 
                      COALESCE(_dlt,-1)<>1 
                      AND _dmn=i18rs._dmn
                      AND _icn=i18rs._fst || '_3'
                  ),
                  i18rs.i18ra4330s,
                  0,
                  now(),
                  now()
                FROM
                  i18rs
                WHERE
                  COALESCE(_dlt,-1)<>1 AND _vsn=_ltt
                  AND _fst={i18r_fst}
                ON CONFLICT ON CONSTRAINT _101_unq1
                DO NOTHING
              `,
              rlcz: {
                i18r_fst: 'i18rs._fst',
              }
            },
            {
              qry: `
                UPDATE
                  _101s
                SET
                  _101a1100s = (
                    SELECT
                      COALESCE(i18rs.i18ra4330s,'')
                    FROM
                      i18rs
                    WHERE
                      COALESCE(_dlt,-1)<>1 AND _vsn=_ltt
                      AND i18rs.i18r_31r1f = _101s._101_31r1f
                      AND _fst = {i18r_fst}
                  )
                WHERE
                  COALESCE(_dlt,-1)<>1
                  AND _101s._101_10r1k = (
                    SELECT
                      _key
                    FROM
                      _10rs
                    WHERE
                      COALESCE(_dlt,-1)<>1
                      AND _10rt1100i = 10
                      AND _icn = '{i18r_fst}' || '_3'
                  )
              `,
              rlcz: {
                i18r_fst: 'i18rs._fst',
              }
            },
          ]
        },

        i18ra5100s: {
          pfx: '次回更新日',
        },
        i18ra5210i: {
          pfx: '１年目確認',
          ls: [
            { key: -1, pfx: '未' },
            { key:  1, pfx: '済' },
          ],
        },
        i18ra5220i: {
          pfx: '２年目確認',
          ls: [
            { key: -1, pfx: '未' },
            { key:  1, pfx: '済' },
          ],
        },
        i18ra5230i: {
          pfx: '３年目確認',
          ls: [
            { key: -1, pfx: '未' },
            { key:  1, pfx: '済' },
          ],
        },
        i18ra5300s: {
          pfx: '更新メモ',
        },

        i18ra6100s: {
          pfx: '活動内容',
        },
        i18ra6200s: {
          pfx: '活動備考',
        },
        i18ra6310i: {
          pfx: '活動頻度区分',
          ls: [
            { key: -1, pfx: ' ' },
            { key: 10, pfx: '月' },
            { key: 20, pfx: '年' },
          ],
        },
        i18ra6320i: {
          pfx: '活動回数',
        },
        i18ra6400i: {
          pfx: '活動時間帯',
          ls: [
            { key: -1, pfx: ' ' },
            { key: 10, pfx: '午前' },
            { key: 20, pfx: '午後' },
            { key: 30, pfx: '夜間' },
            { key: 90, pfx: 'その他' },
          ],
        },
        i18ra6500s: {
          pfx: '活動曜日',
        },

        i18ra7100i: {
          pfx: '会員構成分類区分',
          ls: [
            { key: -1, pfx: ' ' },
            { key: 10, pfx: '一般' },
            { key: 20, pfx: '事後サークル' },
            { key: 30, pfx: '優先団体' },
            { key: 90, pfx: 'その他' },
          ],
        },
        i18ra7200s: {
          pfx: '会員構成分類その他',
        },
        i18ra7310i: {
          pfx: '会員構成人数男性',
        },
        i18ra7320i: {
          pfx: '会員構成人数女性',
        },
        i18ra7330i: {
          pfx: '会員構成人数大人',
        },
        i18ra7340i: {
          pfx: '会員構成人数こども',
        },

        i18ra8100i: {
          pfx: '会費分類',
          ls: [
            { key: -1, pfx: ' ' },
            { key: 10, pfx: '一回' },
            { key: 20, pfx: '月' },
            { key: 30, pfx: '年' },
          ],
        },
        i18ra8200i: {
          pfx: '会費料金',
        },
        i18ra8300i: {
          pfx: '会員募集',
          ls: [
            { key: -1, pfx: 'しない' },
            { key:  1, pfx: 'する' },
          ],
        },

        i18ra9110s: {
          pfx: '指導者名',
        },
        i18ra9120s: {
          pfx: '指導者名かな',
        },
        i18ra9210s: {
          pfx: '連絡者名',
        },
        i18ra9220s: {
          pfx: '連絡者名かな',
        },

        i18raa100i: {
          pfx: '減免率区分',
          ls: [
            { key:   0, pfx: 'なし' },
            { key:  50, pfx: '50%' },
            { key: 100, pfx: '100%' },
            { key: 999, pfx: 'その他' },
          ],
        },
        i18raa200i: {
          pfx: '減免率',
        },
        i18raa300i: {
          pfx: '減免理由区分',
          ls: [
            { key: -1, pfx: ' ' },
            { key: 10, pfx: 'A' },
            { key: 20, pfx: 'B' },
            { key: 30, pfx: 'C' },
            { key: 40, pfx: 'D' },
          ],
        },
        i18rab100s: {
          pfx: '団体番号', // 施設ID + 団体ID
          atrs: [
            {
              qry: `
                UPDATE
                  i18rs
                SET
                  i18rab100s = (
                    SELECT
                      A._icn || '-' || LPAD(i18rs._icn, 5, '0')
                    FROM
                      _31rs AS A
                    WHERE
                      A._dmn = i18rs._dmn
                      AND COALESCE(A._dlt,-1) <> 1
                      AND A._vsn = A._ltt
                      AND A._fst = i18rs.i18r_31r1f
                  )
                WHERE
                  _dmn = {i18r_dmn}
                  AND COALESCE(_dlt,-1) <> 1
                  AND _vsn = _ltt
                  AND _fst = {i18r_fst}
                  AND COALESCE(i18rab100s,'') = ''
              `,
              rlcz: {
                i18r_dmn: 'i18rs._dmn',
                i18r_fst: 'i18rs._fst',
              }
            }
          ]
        },
/*
        i18rac100s: {
          pfx: '利用区分', // 利用者数一覧出力用
        },
*/
      },
    },
  },
};
